import { Colors } from '../../consts/Colors';
import RoundedButton2 from '../RoundedButton2';
import Card2 from './Card2';
import { CartesInfos, TextContents } from '../../consts/DataGame2.js';
import DragManager from '../DragManager';

// Création du deck de jeu pour la partie 2

export default class Deck2 extends Phaser.GameObjects.Container {
    constructor(scene, x, y) {
        super(scene, x, y, []);
        scene.add.existing(this);

        this.scene = scene;
        this.isFirstDrop = true
        this.placeholders = [];
        this.cartes = [];


        this.rect = this.scene.add.rexRoundRectangle(0, 0, 416, 593, 26, Colors.Elmt.Beige).setOrigin(0.5);
        this.rect.setStrokeStyle(2, Colors.Elmt.White, 1);
        this.add(this.rect);

        this.validBtn = new RoundedButton2(this.scene, 0, 247, 154, "Valider");
        this.add(this.validBtn);
        this.validBtn.setClickFunction(() => {
            this.checkAnswer()
        })

        this.dragManager = new DragManager(this.scene);
        for (let i = 0; i < CartesInfos.length; i++) {
            const el = CartesInfos[i];
            let phImg = "labelSlot"
            if (i === 3 || i === 2) {
                phImg = "arrowSlot"
            }
            this.ph = this.scene.add.image(0, el.cardY - 2.5, phImg).setOrigin(0.5);
            this.add(this.ph);
            this.placeholders.push(this.ph);
            this.carte = new Card2(this.scene, 0, el.cardY, el, this);
            this.add(this.carte);
            this.cartes.push(this.carte);
            this.dragManager.addDraggable(this.carte);
        }

        this.validBtn.setLocked()

        this.title = this.scene.createTextElement(-208, -481, TextContents.title)
        this.subtitle = this.scene.createTextElement(-208, -448, TextContents.subtitle)
        this.consigne = this.scene.createTextElement(-193, 328, TextContents.consigne)
        this.add(this.title)
        this.add(this.subtitle)
        this.add(this.consigne)
    }
    setDeckTrue() {
        this.repLogo = this.scene.add.image(-93, -60, 'goodAnswer').setOrigin(0.5)
        this.add(this.repLogo)
        this.repText = this.scene.add.text(-59, -75, "BRAVO", {
            font: "40px MassiliaBold",
            color: Colors.Text.Green
        }).setOrigin(0)
        this.add(this.repText)
        this.repContent = this.scene.add.text(0, -25, "Vous avez placé correctement les éléments qui différencient la procédure amiable de la procédure collective.", {
            font: "22px MassiliaRegular",
            color: Colors.Text.Blue,
            align: "center",
            wordWrap: { width: 340, useAdvancedWrap: true }
        }).setOrigin(0.5, 0)
        this.add(this.repContent)
        this.nextBtn = new RoundedButton2(this.scene, 0, 231, 188, "Continuer");
        this.add(this.nextBtn);
        this.nextBtn.setClickFunction(() => {
            this.scene.transitionOut()
        })
    }
    setDeckFalse(score) {
        let content
        if (score == 3) {
            content = "1 MAUVAISE RÉPONSE"
        } else if (score == 2) {
            content = "2 MAUVAISES RÉPONSES"
        } else if (score == 1) {
            content = "3 MAUVAISES RÉPONSES"
        } else if (score == 0) {
            content = "4 MAUVAISES RÉPONSES"
        }
        this.repLogo = this.scene.add.image(0, -72, 'badAnswer').setOrigin(0.5)
        this.add(this.repLogo)
        this.repText = this.scene.add.text(0, -24, content, {
            font: "40px MassiliaBold",
            color: Colors.Text.Red,
            wordWrap: { width: 255, useAdvancedWrap: true },
            align: "center"
        }).setOrigin(0.5, 0)
        this.add(this.repText)
        this.nextBtn = new RoundedButton2(this.scene, 0, 245, 188, "Réessayer");
        this.add(this.nextBtn);
        this.nextBtn.setClickFunction(() => {
            this.cartes.forEach(carte => {
                if (carte.isCorrect === false) {
                    carte.reset()
                    this.nextBtn.destroy()
                    this.placeholders.forEach(ph => { ph.setAlpha(1) })
                    this.validBtn.setAlpha(1)
                    this.repLogo.destroy()
                    this.repText.destroy()
                }
            })
        })
    }

    checkAnswer() {
        this.result = 0
        this.cartes.forEach(carte => {
            carte.disableInteractive()
            if (carte.zoneDroped.zoneId === carte.zoneId) {
                if (this.isFirstDrop === true) {
                    this.scene.game.data.score.bravo++
                }
                carte.setGood()
                carte.isCorrect = true
                this.result++
            } else {
                carte.isCorrect = false
                if (this.isFirstDrop === true) {
                    this.scene.game.data.score.mauvais++
                }
                carte.setBad()
            }
        })
        this.isFirstDrop = false
        this.placeholders.forEach(ph => { ph.setAlpha(0) })
        this.validBtn.setAlpha(0)
        if (this.result == 4) {
            this.setDeckTrue()
        } else {
            this.setDeckFalse(this.result)
        }
    }
}